import React, { useState, useEffect } from "react";
import ReactMapGL, { Marker, Popup, Source, Layer } from "react-map-gl";

import RoomIcon from "@mui/icons-material/Room";
import PersonPinCircleIcon from "@mui/icons-material/PersonPinCircle";
import CancelIcon from "@mui/icons-material/Cancel";

import "./SidebarVillageDetails.css";
import { useDispatch, useSelector } from "react-redux";
import { setSidebarVisibility } from "../../redux/reducers/selectedVillageDetails";
import Translate from "../Translate/Translate";

function SidebarVillageDetails(props) {
  const villageDetails = useSelector(
    (state) => state.selectedVillageDetails.data
  );
  const showSidebar = useSelector(
    (state) => state.selectedVillageDetails.showSidebar
  );

  console.log("village details are ", typeof villageDetails);

  const dispatch = useDispatch();

  return (
    showSidebar && (
      <div className="site-info-sidebar-container">
        <div className="site-info-sidebar-header">
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <h4
              style={{
                fontSize: "1.5rem",
                fontWeight: "bold",
                color: "lightblue",
              }}
            >
              <Translate text={`Village Details `} />
            </h4>

            <div onClick={() => {}}>
              <a href={villageDetails.village_location} target="_blank">
                <RoomIcon
                  className="cursor-pointer"
                  fontSize="small"
                  style={{ color: "black" }}
                />
              </a>
            </div>

            <div onClick={() => {}}>
              <a
                href={`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${villageDetails.village_latitude},${villageDetails.village_longitude}`}
                target="_blank"
              >
                <PersonPinCircleIcon
                  className="cursor-pointer"
                  fontSize="small"
                  style={{ color: "black" }}
                />
              </a>
            </div>

            <div
              onClick={() => {
                console.log("cross clicked***************");
                dispatch(setSidebarVisibility(false));
              }}
            >
              <CancelIcon
                className="cursor-pointer"
                fontSize="small"
                style={{ color: "var(--text-color)" }}
              />
            </div>
          </div>
        </div>

        <div className="site-info-details-container">
          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"VILLAGE NAME"} />
              </h5>
            </div>
            <p>
              <Translate
                text={villageDetails.village || "No village name Available"}
              />
            </p>
          </div>

          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"AREA"} />
              </h5>
            </div>
            <p>
              <Translate text={villageDetails.area || "No Area Available"} />
            </p>
          </div>

          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"BLOCK NAME"} />
              </h5>
            </div>
            <p>
              <Translate
                text={villageDetails.block_name || "No Block Name Available"}
              />
            </p>
          </div>

          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"DEVLOPMENT"} />
              </h5>
            </div>
            <p>
              <Translate
                text={villageDetails.devlopment || "No Devlopment Available"}
              />
            </p>
          </div>
          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"DIST_SUB_C"} />
              </h5>
            </div>
            <p>
              <Translate
                text={villageDetails.dist_sub_c || "No Dist_Sub_C Available"}
              />
            </p>
          </div>
          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"DIST_TWN_C"} />
              </h5>
            </div>
            <p>
              <Translate
                text={villageDetails.dist_twn_c || "No Dist_Twn_C Available"}
              />
            </p>
          </div>
          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"DISTRICT"} />
              </h5>
            </div>
            <p>
              <Translate
                text={villageDetails.district || "No District Available"}
              />
            </p>
          </div>
          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"GOVERNMENT STATUS"} />
              </h5>
            </div>
            <p>
              <Translate
                text={villageDetails.gov_status || "No GOVT Status Available"}
              />
            </p>
          </div>
          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"KHASRA"} />
              </h5>
            </div>
            <p>
              <Translate
                text={villageDetails.khasra || "No Khasra Available"}
              />
            </p>
          </div>
          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"KHATA NUMBER"} />
              </h5>
            </div>
            <p>
              <Translate
                text={villageDetails.khata_num || "No Khata Number Available"}
              />
            </p>
          </div>
          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"LATITUDE"} />
              </h5>
            </div>
            <p>
              <Translate
                text={
                  villageDetails.village_latitude || "No Latitude Available"
                }
              />
            </p>
          </div>
          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"LONGITUDE"} />
              </h5>
            </div>
            <p>
              <Translate
                text={
                  villageDetails.village_longitude || "No longitude Available"
                }
              />
            </p>
          </div>
          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"PARGANA"} />
              </h5>
            </div>
            <p>
              <Translate
                text={villageDetails.pargana || "No Pargana Available"}
              />
            </p>
          </div>
          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"S_CODE"} />
              </h5>
            </div>
            <p>
              <Translate
                text={villageDetails.s_code || "No s_code Available"}
              />
            </p>
          </div>
          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"TAHSIL"} />
              </h5>
            </div>
            <p>
              <Translate
                text={villageDetails.tahsil || "No Tahsil Available"}
              />
            </p>
          </div>
          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"TSHT"} />
              </h5>
            </div>
            <p>
              <Translate text={villageDetails.tsht || "No TSHT Available"} />
            </p>
          </div>
          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"uNumber"} />
              </h5>
            </div>
            <p>
              <Translate
                text={villageDetails.uNumber || "No uNumber Available"}
              />
            </p>
          </div>
          <div className="site-info-details-sub-container">
            <div
              style={{ display: "flex", gap: "0.3rem", alignItems: "center" }}
            >
              <h5 className="m-0">
                <Translate text={"VILLAGE_CO"} />
              </h5>
            </div>
            <p>
              <Translate
                text={villageDetails.village_co || "No village_co Available"}
              />
            </p>
          </div>
        </div>

        <ZonePolygon
          key={villageDetails.khasra}
          zoneData={villageDetails}
          layerFill={"yellow"} // Highlight selected village
        />
      </div>
    )
  );
}

const ZonePolygon = ({ zoneData, layerFill }) => {
  return (
    <Source
      id={`village-selected-${zoneData.khasra}`}
      type="geojson"
      data={{
        type: "Feature",
        geometry:
          typeof zoneData.village_geometry === "string"
            ? JSON.parse(zoneData.village_geometry)
            : zoneData.village_geometry,
        properties: { ...zoneData }, // Attach village properties
      }}
    >
      <Layer
        id={`layer-selected-${zoneData.khasra}`}
        type="fill"
        paint={{
          "fill-color": layerFill,
          "fill-opacity": 0.3,
        }}
      />
    </Source>
  );
};

export default SidebarVillageDetails;
